import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ObjectBaseModeComponent} from '../../../../../../../core/shared/object/mvs-object-base/object-base-mode.component';
import {HgImportDto} from '../../../../../model/dto/entity/hg-import.dto';
import {HgImportStatusInternalEnum} from '../../../../../model/dto/enum/hg-import-status-internal.enum';
import {EiImportService} from '../../../../../../ei/service/api/ei-import.service';
import {EiImportDto} from '../../../../../../ei/model/dto/entity/ei-import.dto';
import {
    MvsObjectNavigationService
} from '../../../../../../../core/shared/navigation/mvs-object-navigation.service';
import {
    MvsObjectNavigationEntry
} from '../../../../../../../core/shared/navigation/mvs-object-navigation-entry';
import {
    MvsObjectNavigationActionEnum
} from '../../../../../../../core/shared/navigation/mvs-object-navigation-action-enum';

/**
 * Compact side view for the HgImport ObjectBaseComponent.
 *
 * Renders a condensed summary of the import (Partner, Status, Dokument, kurze
 * EI-Fortschrittsanzeige) and a "Details öffnen" action that deep-links to the
 * full OBC view.
 *
 * Read-only.
 */
@Component({
    selector: 'hg-import-object-side',
    templateUrl: './hg-import-object-side.component.html',
    standalone: false
})
export class HgImportObjectSideComponent extends ObjectBaseModeComponent implements OnInit, OnChanges, OnDestroy {

    @Input() override dto: HgImportDto;

    override initialized: boolean = false;

    /** Nachgeladene EI-Import-Zahlen für die kurze Fortschrittsanzeige. */
    eiImport: EiImportDto | null = null;
    eiImportLoading: boolean = false;

    protected readonly HgImportStatusInternalEnum = HgImportStatusInternalEnum;

    constructor(
        protected route: ActivatedRoute,
        protected eiImportService: EiImportService,
        protected navigationService: MvsObjectNavigationService) {
        super(route);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.refreshComponent();
    }

    refreshComponent(): void {
        this.loadEiImport();
        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['dto']) {
            this.loadEiImport();
        }
    }

    ngOnDestroy(): void {
    }

    /**
     * Loads the referenced EiImport for the progress summary.
     * Silently ignores errors — the side view still renders.
     */
    private loadEiImport(): void {
        if (!this.dto?.eiImportDtoId) {
            this.eiImport = null;
            return;
        }
        this.eiImportLoading = true;
        this.eiImportService.get(this.dto.eiImportDtoId).subscribe({
            next: (res) => {
                this.eiImport = res as EiImportDto;
                this.eiImportLoading = false;
            },
            error: () => {
                this.eiImport = null;
                this.eiImportLoading = false;
            }
        });
    }

    /**
     * Opens the HgImport OBC in full mode (deep-link from side view).
     */
    openDetails(): void {
        if (!this.objectIdentifier?.objectId) {
            return;
        }
        const entry = MvsObjectNavigationEntry.createNavigationEntry(
            'hg.HgImport',
            this.objectIdentifier.objectId,
            'object',
            this.dto?.hgPartnerDtoName || '',
            '',
            '',
            MvsObjectNavigationActionEnum.edit
        );
        this.navigationService.navigateTo(entry, 'main');
    }
}
